import { Stack } from '@mui/material';
import AccountPopover from './AccountPopover';
import ServicePopover from './ServicePopover';

function jnzAuthComponent({ spacing = { xs: 0.5, sm: 2 } }) {
  return <Stack direction="row" alignItems="center" spacing={spacing}>
    <ServicePopover />
    <AccountPopover />
  </Stack>
}

export default jnzAuthComponent;
